import { datadogLogs } from '@datadog/browser-logs';
import Cookies from 'js-cookie';

// Regex provided by BE to check if GA cookies are valid
const BE_GA_REGEX = /^GA\d\.\d+\.\d+\.\d+$/;
const BE_GA_MEASUREMENT_REGEX =
  /^GS\d\.\d+\.s\d+\$o\d+\$g\d+\$t\d+\$j\d+\$l\d+\$h\d+(\$d[a-zA-Z\d]{34})?$/;

export const getAnalyticsCookies = () => {
  const analyticsCookies = [];

  // Measurement cookie name
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID || '';
  const [, secondCookieName] = measurementId.split('-');

  // Cookies values
  const gaValue = Cookies.get('_ga') || '';
  const ga4Value = Cookies.get(`_ga_${secondCookieName}`) || '';

  if (BE_GA_REGEX.test(gaValue)) {
    analyticsCookies.push({
      name: 'ga',
      value: gaValue,
    });
  }

  if (BE_GA_MEASUREMENT_REGEX.test(ga4Value)) {
    analyticsCookies.push({
      name: `ga_${secondCookieName}`,
      value: ga4Value,
    });
  }

  // log to investigate how many clients don't have valid cookies on PROD
  if (
    analyticsCookies.length < 2 &&
    process.env.REACT_APP_ENV === 'production'
  ) {
    datadogLogs.logger.error(
      `gacookies missing. ga - ${gaValue} + ga_${secondCookieName} - ${ga4Value}`,
    );
  }

  return analyticsCookies;
};
